module.exports = __webpack_public_path__ + "static/media/individual_aacount.408dea63.svg";